import React, { Component } from 'react';

import { connect } from 'react-redux';
import { AdditionalAxaAuth } from '../../../../types/authTypes';
import { getAdditionalAccessTokens } from '../../../../selectors/authSelectors';
import {
  getAdditionalAccessTokenScope,
  getHealthKeeperRequestBody,
  getHealthKeeperUrl,
} from '../../selectors/configSelectors';
import {
  stringFormatter,
  __DEV__,
  resolveLocalizedText,
} from '../../../../utils';
import { getLanguage } from '../../../../selectors/userSelectors';
import LoadingView from '../../../../components/LoadingView';

interface HealthKeeperRedirectScreenProps {
  auth?: AdditionalAxaAuth;
  scope: string;
  requestBody: string;
  url: string;
}

class HealthKeeperRedirectScreen extends Component<HealthKeeperRedirectScreenProps> {
  form?: HTMLFormElement;

  componentDidMount() {
    if (this.form) {
      this.form && this.form.submit();
    }
  }

  render() {
    const { url, requestBody, auth } = this.props;

    if (!!auth && !!auth.refreshToken) {
      const formatterRequestBody = stringFormatter(requestBody, {
        token: auth.token,
        refreshToken: auth.refreshToken,
        expiresIn: `${auth.expiresIn}`,
        scope: auth.scope,
        language: getLanguage(),
      });

      return (
        <div>
          <LoadingView fromScreenTop={true} />
          <form
            ref={(ref) => (this.form = ref || undefined)}
            action={url}
            method="POST"
            encType="application/x-www-form-urlencoded"
          >
            {formatterRequestBody.split('&').map((kv) => {
              const segments = kv.split('=');
              const name = segments[0];
              const value = segments[1];
              return <input name={name} value={value} />;
            })}
            {__DEV__ && <input name={`__DEV__`} value={`__DEV__`} />}
            <input type="submit" value="submit" />
          </form>
        </div>
      );
    } else {
      throw new Error(`Error 400`);
    }
  }

  static mapStateToProps(state: any, ownProps: any) {
    const scope = getAdditionalAccessTokenScope(state);
    const additonalAccessTokens = getAdditionalAccessTokens(state);
    const auth = additonalAccessTokens.find((a) => a.scope === scope);
    const url = resolveLocalizedText(getHealthKeeperUrl(state));
    return {
      scope,
      auth,
      requestBody: getHealthKeeperRequestBody(state),
      url,
    };
  }

  static mapDispatchToProps(dispatch: any) {
    return {};
  }
}

export default connect(
  HealthKeeperRedirectScreen.mapStateToProps,
  HealthKeeperRedirectScreen.mapDispatchToProps,
)(HealthKeeperRedirectScreen);
